import { AfterContentInit, Directive, ElementRef, Host } from '@angular/core';
import { Subject, combineLatest, fromEvent } from 'rxjs';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { KeyboardListDirective } from './keyboard-list.directive';
import { KeyboardUtils } from './keyboard.utils';

/**
 * Eine Direktive, die die Suche nach Buchstabe in einer List ermöglicht.
 * Erfordert KeyboardListDirective.
 */
@Directive({
    selector: '[commonKeyboardSymbolSearch]'
})
export class KeyboardSymbolSearchDirective<T> implements AfterContentInit {

    private ngUnsubscribe$: Subject<void> = new Subject<void>();

    constructor(@Host() private keyboardList: KeyboardListDirective<T>,
                private elementRef: ElementRef) {
    }

    ngAfterContentInit(): void {
        const items$ = this.keyboardList.items.changes.pipe(
            startWith(this.keyboardList.items),
            filter(items => items.length > 0),
            map(items => items.toArray())
        );
        const keydown$ = fromEvent<KeyboardEvent>(this.elementRef.nativeElement, 'keydown');
        combineLatest([keydown$, items$]).pipe(
            map(([k, items]) => ([k, this.keyboardList.getSelectedIndex(), items])),
            KeyboardUtils.findIndexBySymbolOperator,
            filter(x => x !== -1),
            takeUntil(this.ngUnsubscribe$)
        )
            .subscribe((index: number) => this.keyboardList.moveTo(index));
    }
}
